function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import ImageLoader from './imageLoader';
import { getImageSrc } from '../../utils/imageUtils';
import imageLayout from './imageLayout';
import imageLayoutResponsive from './imageLayoutResponsive';
var TIMEOUT = 250;

function wixImageWrapper(WixElement, services, environmentConsts) {
  if (!services.imageLoader) {
    services.imageLoader = new ImageLoader(services.mutationService);
  }

  var WixImage = /*#__PURE__*/function (_WixElement) {
    _inheritsLoose(WixImage, _WixElement);

    function WixImage() {
      var _this;

      // eslint-disable-line no-useless-constructor
      _this = _WixElement.call(this) || this;
      _this.childListObserver = null;
      _this.timeoutId = null;
      return _this;
    }

    var _proto = WixImage.prototype;

    _proto.reLayout = function reLayout() {
      //todo: temp experiment for measuring purposes, should be removed after test results
      if (services.isExperimentOpen('specs.thunderbolt.tb_stop_client_images')) {
        return;
      }

      var domNodes = {};
      var measures = {};
      var imageId = this.getAttribute('id');
      var imageInfo = JSON.parse(this.dataset.imageInfo);
      var isSvg = this.dataset.isSvg === 'true';
      var isSvgMask = this.dataset.isSvgMask === 'true';
      var isResponsive = this.dataset.isResponsive === 'true';
      var bgEffectName = this.dataset.bgEffectName;
      domNodes[imageId] = this;

      if (imageInfo.containerId) {
        domNodes[imageInfo.containerId] = document.getElementById("" + imageInfo.containerId);
      }

      domNodes.image = this.querySelector(isSvg ? 'image' : 'img');
      domNodes.svg = isSvg ? this.querySelector('svg') : null;
      domNodes.picture = this.querySelector('picture');
      var containerElm = imageInfo.containerId && domNodes[imageInfo.containerId]; //override positioning and scaling of image (SiteBackground mobile override behaviour)

      var mediaHeightOverrideType = containerElm && containerElm.dataset.mediaHeightOverrideType;

      if (isSvgMask) {
        domNodes.maskSvg = domNodes.svg && domNodes.svg.querySelector('svg');
      }

      if (!domNodes.image) {
        // missing children, can't layout, wait for children to be created first
        // if isSvg==false || we don't have SVG yet -> use `this`
        var target = isSvg ? domNodes.svg || this : this;
        this.observeChildren(target);
        return;
      } // clean up


      this.unobserveChildren(); // from now on just observe changes to children of top level

      this.observeChildren(this); // perform the layout

      var layout = isResponsive || domNodes.picture ? imageLayoutResponsive : imageLayout; // TODO: remove domNodes.picture after wix-ui-santa comes to production 08/03/2020

      services.mutationService.measure(function () {
        layout.measure(imageId, measures, domNodes, {
          containerElm: containerElm,
          isSvg: isSvg,
          isSvgMask: isSvgMask,
          mediaHeightOverrideType: mediaHeightOverrideType,
          bgEffectName: bgEffectName
        }, services);
      });

      var patchImage = function patchImage(shouldLoadImage) {
        services.mutationService.mutate(function () {
          layout.patch(imageId, measures, domNodes, imageInfo, services, environmentConsts, shouldLoadImage, bgEffectName);
        });
      }; // if image has no src or current src if from ssr render stage  -
      // load the image immediately, otherwise - debounce the reload


      if (!getImageSrc(domNodes.image, isSvg) || this.dataset.hasSsrSrc) {
        patchImage(true);
      } else {
        this.debounceImageLoad(patchImage);
      }
    }
    /**
     * Debounce consecutive image loads
     *
     * @param patchImage - closure for patching the image
     */
    ;

    _proto.debounceImageLoad = function debounceImageLoad(patchImage) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(function () {
        patchImage(true);
      }, TIMEOUT);
      patchImage(false);
    };

    _proto.attributeChangedCallback = function attributeChangedCallback(name, oldValue) {
      if (oldValue) {
        this.reLayout();
      }
    };

    _proto.disconnectedCallback = function disconnectedCallback() {
      _WixElement.prototype.disconnectedCallback.call(this);

      services.imageLoader.onImageDisconnected(this);
      this.unobserveChildren();
    };

    _createClass(WixImage, null, [{
      key: "observedAttributes",
      get: function get() {
        return ['data-image-info'];
      }
    }]);

    return WixImage;
  }(WixElement);

  return WixImage;
}

export default wixImageWrapper;
//# sourceMappingURL=wixImage.js.map